import { listKeyitem } from './../../../../shared/Models/SelectItems';

import { SourcesValues } from '../../models/source.values';

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbToastrService, NbComponentStatus, NbDialogRef } from '@nebular/theme';
import { DataSourceValuesService } from '../../services/data.cource.values';

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss'],
})
export class CreateDataSourceValuesComponent implements OnInit {
  requiredCreateDate: listKeyitem[] = [];
  sourcesValues: SourcesValues = {} as SourcesValues;
  users: any[];
  legals: any[];
  userSectionFlg: boolean;
  legalSectionFlg: boolean;
  userEscalationSectionFlg: boolean;
  escalDays: number;
  escaleHours: number;
  formMasterId: number;
  finishLoading: boolean;
  constructor(
    private service: DataSourceValuesService,
    private route: ActivatedRoute,
    private toastrService: NbToastrService,
    private router: Router,
    private diag: NbDialogRef<CreateDataSourceValuesComponent>
  ) {}
 
  ngOnInit() {
      this.router.events.subscribe(()=>{
      this.diag.close('false');
     });
    this.sourcesValues.dataSourceMasterId = this.formMasterId;
   //  this.loadRequiredCreateDate();
    // this.phase.workFlowId = this.route.snapshot.params.id;
    // this.phase.escalationVm = {} as Escalation;
    // this.phase.optimal = {} as PhaseDateTime;
    // this.phase.normal = {} as PhaseDateTime;
  }
  loadRequiredCreateDate() {
    this.service.getCreateNew().subscribe((res) => {
      this.requiredCreateDate = res;
      this.finishLoading = true;
    });
  }

  addNewPhase() {

    this.service.post(this.sourcesValues).subscribe((res) => {});
  }
  dropdownChange($event) {
    switch ($event) {
      case 1:
        this.initalize();
        this.userSectionFlg = true;
        this.service.getPhaseUsers(1).subscribe((res) => {
          this.users = res;
        });
        // this.users = [{ name: 'ali', id: 2 }];
        break;
      case 2:
        this.initalize();
        this.legalSectionFlg = true;
        this.service.getPhaseUsers(2).subscribe((res) => {
          this.legals = res;
        });
        break;
      default:
        this.initalize();
    }
  }
  escalationChange($event) {
    switch ($event) {
      case 3:
        if (this.users == null || this.users.length === 0) {
          this.service.getPhaseUsers(1).subscribe((res) => {
            this.users = res;
          });
        }
        this.userEscalationSectionFlg = true;
        break;
      default:
        this.userEscalationSectionFlg = false;
    }
  }

  initalize() {
    this.userSectionFlg = false;
    this.legalSectionFlg = false;
  }
  save() {
    // console.log(this.phase);
    // this.phase.FlgAssignRef = 1;
    // this.phase.FlgAssignType = 1;
    // this.phase.escalationVm.flgEscaleToType = 1;
    // this.phase.escalationVm.escaleToRef = '1';
    // this.phase.escalationVm.flgPeriodRef = 3;
    // this.phase.escalationVm.flgPeriodType = 3;
    this.service.post(this.sourcesValues).subscribe((res) => {
      const position = 'bottom-right';
      this.toastrService.success( `add source value successfully`, 'success');
      this.diag.close('true');
      // this.phase = {} as Phases;
      // console.log(res);
    });
  }
  showToast(position, message, status: NbComponentStatus) {
    this.toastrService.show(message, '', { position, status });
  }
  back() {
    const route = ['workflow'];
    this.router.navigate(route);
  }
}
